// extracted by mini-css-extract-plugin
module.exports = {"slider":"t3mEs5RTTZgqs6ZXBRTO1Q==","sliderOFF":"v8swaq9cJ17180SshwddMA==","status":"UQpJDgpNxgWM76EKQ99Pcw==","disabled":"xJt9YmYUz9TnwHeT5I929g=="};